import { coerceNumberProperty } from "@angular/cdk/coercion";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { ActiontrackerConstantsService } from "../../../actiontracker/services/actiontracker-constants.service";
import { UnitTreeNode } from "../../../masterscreen/model/unit-tree.model";
import { MasterscreenService } from "../../../masterscreen/services/masterscreen.service";
import { ActionListForHSEAdvisor } from "../../../observation/components/raise-observation/raise-observation.component";
import { User } from "../../../observation/model/user.model";
import { ObservationService } from "../../../observation/services/observation.service";
import { SpecificationData } from "../../../shared/components/category/category.component";
import { UserLogInActivity, UserPermissionParameters } from "../../../shared/models/user.model";
import { BaseService } from "../../../shared/services/base.service";
import { ConstantsService } from "../../../shared/services/constants.service";
import { NotificationsService } from "../../../shared/services/notification.service";
import { FileUtility } from "../../../shared/utility/file.utility";
import { RiskPermission } from "../../model/riskpermission.model";
import { RiskRequest } from "../../model/riskRequest.model";
import { AssignActionPost } from "./../../../actiontracker/model/actionDetails.model";
import { SearchText } from "./../../../observation/model/searchTexts.model";
import { CommonService } from "./../../../shared/services/common.service";
import { RaiseRiskAllMaster } from "./../../model/raiseRiskAllMaster";
import { AssetsRisk, EnvironmentRisk, NPTRisk, PearDetails, PeopleRisk, RaiseRisk, RaiseRiskShowErrorMessages, ReputationRisk } from "./../../model/riskRequest.model";
import { RiskConstantsService } from "./../../services/risk-constants.service";
import { RiskService } from "./../../services/risk.service";
import { ObservationConstantsService } from "../../../observation/services/observation-constants.service";

@Component({
  selector: "ara-raise-risk",
  templateUrl: "./raise-risk.component.html",
  styleUrls: ["./raise-risk.component.css"]
})
export class RaiseRiskComponent implements OnInit {
  loggedInUser = this.baseService.getItemFromSession("loggedInUser");
  loggedInUserJSON = JSON.parse(this.loggedInUser);
  raiseRisk = new RaiseRisk();
  raiseRiskAllMaster = new RaiseRiskAllMaster();
  riskRequest = new RiskRequest();
  updateriskData = new RiskRequest();
  PotentialPeopleRisk = new PeopleRisk();
  PotentialAssetsRisk = new AssetsRisk();
  PotentialEnvironmentRisk = new EnvironmentRisk();
  PotentialReputationRisk = new ReputationRisk();
  PotentialNPTRisk = new NPTRisk();
  PotentialRAMClassificationList: Array<any> = [];

  ResidualPeopleRisk = new PeopleRisk();
  ResidualAssetsRisk = new AssetsRisk();
  ResidualEnvironmentRisk = new EnvironmentRisk();
  ResidualReputationRisk = new ReputationRisk();
  ResidualNPTRisk = new NPTRisk();
  ResidualRAMClassificationList: Array<any> = [];

  RiskassessmentPeople = new PeopleRisk();
  RiskassessmentAssets = new AssetsRisk();
  RiskassessmentEnvironment = new EnvironmentRisk();
  RiskassessmentReputation = new ReputationRisk();
  RiskassessmentNPT = new NPTRisk();
  RiskassessmentClassificationList: Array<any> = [];
  pearMaster: any = [];
  riskMovement: any = [];
  consequenceMaster: any = [];
  severityMaster: any = [];
  potentialRiskColor = "";
  residualRiskColor = "";
  actionList: any = [];
  actionPost: AssignActionPost | undefined;
  searchTexts: SearchText = new SearchText();
  userResults: User[] = [];
  displayErrorMessage: any;
  successDetails: string = "";
  errorDetails: any;
  alertType: string = "";
  confirmMessage: string = "";
  isUserHasHSEMemberRole: boolean = false;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[] | undefined;
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[] | undefined;
  selectedRiskRequestId: number = 0;
  UpdatedPotentialPear: PearDetails[] | undefined;
  UpdatedResidualPear: PearDetails[] | undefined;
  UpdatedAssessmentPear: PearDetails[] | undefined;
  data: CustomObject[] = [];

  ShowPeopleSeverityMessage: boolean = false;
  ShowPeopleLikelihooodMessage: boolean = false;
  ShowEnvironmentSeverityMessage: boolean = false;
  ShowEnvironmentlihooodMessage: boolean = false;
  ShowAssetsSeverityMessage: boolean = false;
  ShowAssetslihooodMessage: boolean = false;
  ShowReputationSeverityMessage: boolean = false;
  ShowReputationlihooodMessage: boolean = false;
  ShowNPTSeverityMessage: boolean = false;
  ShowNPTlihooodMessage: boolean = false;

  residualPeopleSeverityMessage: boolean = false;
  residualPeopleLikelihooodMessage: boolean = false;
  residualEnvironmentSeverityMessage: boolean = false;
  residualEnvironmentlihooodMessage: boolean = false;
  residualAssetsSeverityMessage: boolean = false;
  residualAssetslihooodMessage: boolean = false;
  residualReputationSeverityMessage: boolean = false;
  residualReputationlihooodMessage: boolean = false;
  residualNPTSeverityMessage: boolean = false;
  residualNPTlihooodMessage: boolean = false;

  assessmentPeopleSeverityMessage: boolean = false;
  assessmentPeopleLikelihooodMessage: boolean = false;
  assessmentEnvironmentSeverityMessage: boolean = false;
  assessmentEnvironmentlihooodMessage: boolean = false;
  assessmentAssetsSeverityMessage: boolean = false;
  assessmentAssetslihooodMessage: boolean = false;
  assessmentReputationSeverityMessage: boolean = false;
  assessmentReputationlihooodMessage: boolean = false;
  assessmentNPTSeverityMessage: boolean = false;
  assessmentNPTlihooodMessage: boolean = false;
  ShowriskMovementmessage: boolean = false;
  GraphDisplay: boolean = false;
  max: number = 0;
  pear: string = "";
  retVal: boolean | undefined;
  userActivityList: UserLogInActivity[] = [];
  deletionReason: any;
  isDeletionreason: boolean | undefined;
  isActionOpen: boolean = false;
  actionDetailsForHseAdvisor: ActionListForHSEAdvisor;
  cancelRecord: boolean | undefined;
  deleteRecord: boolean | undefined;
  deleteActionId: number | undefined;
  actionStatusId: number = 25;
  cancelActionId: any;
  cancellationReason: any;
  cancelStatusId: number = 26;
  showCancellationmsg: boolean = false;
  validatePopUp: boolean = false;
  showDeletionmsg: boolean = false;
  disableRisk: boolean = false;
  riskPermission: RiskPermission;
  userPermissions: UserPermissionParameters;
  unitList: any[] = [];
  selectedUnit: any;
  isNew: boolean = false;
  updateriskDataForDetails: any = [];
  riskLoaded: boolean | undefined;
  tempUnits: string | undefined;
  environmentMaster: any = [];
  assetsMaster: any = [];
  reputationMaster: any = [];
  NPTMaster: any = [];
  riskIds: any[] = [];
  riskIndex: number = -1;
  isNext: boolean = true;
  isPrevious: boolean = true;
  alertFrom: string = "";
  moduleList: any[] = [];
  moduleId: number = 0;
  specificationDetailsData: SpecificationData;
  lifeSavingCheckedValueData: any[] = [];
  sourceId: number = 0;
  unitTree: UnitTreeNode[] = [];
  accept: string;
  tempFiles: any[] = [];
  multiple: boolean = true;
  independentPermissions: any;
  isActive: boolean = false;
  lifeSavingCheckedValue: any[];
  specificationResponseData: SpecificationData;
  public isShowCategory: boolean = false;
	isShowSpecification: boolean = false;
  specificationData: SpecificationData[];
    //BOC Pritesh
    dialogHeight: string;
    dialogWidth: string;
    ReportUserId : number;
    ReportModule : string;
    ReportRecordId : number;
    ReportProcessId : number = 0;
    ReportclosePopup: boolean = false;
    //EOC Pritesh
    unitError : boolean;
    editEnabled: boolean = true;
    IsNewRecord:boolean = true;

    contracts: { label: string; value: string }[] = [];
    unitContractDetails: any[] = [];
    isHasContractDetails: boolean = true;
    isContractErrorMsg: boolean = true;
    isEmployeeUnit:boolean=true;
    isContractHolder: boolean = false;
    selectedContractId: number;

  constructor(
    private ref: ChangeDetectorRef,
    private riskService: RiskService,
    private baseService: BaseService,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private observationService: ObservationService,
    private masterscreenService: MasterscreenService,
    private notificationsService: NotificationsService,
    private translate: TranslateService
  ) {
    this.data = [];
    this.riskRequest = new RiskRequest();
    this.actionDetailsForHseAdvisor = new ActionListForHSEAdvisor();
    this.riskPermission = new RiskPermission();
    this.userPermissions = new UserPermissionParameters();
    this.specificationDetailsData = new SpecificationData();
    this.accept =
      ".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF,.xls,.XLS";
  }
	
  ngOnInit() {
    this.baseService.showRootLoader = true;
    const apiRequestUnit = {
      Model: {
        ModuleId: ConstantsService.PermissionMatrixModules.Risk,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : this.IsNewRecord
      }
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
     

    // Set routeURL and route name for Risk
    this.routesFlag = RiskConstantsService.RiskNavigation.InnerRoutes;
    this.reportRoutes = RiskConstantsService.RiskNavigation.ReportRoutes;
    this.route.params.subscribe(params => {
      this.selectedRiskRequestId = coerceNumberProperty(params["riskId"]);
      this.sourceId = this.selectedRiskRequestId;
    });
    this.pearMaster = RiskConstantsService.Pear;
    this.riskMovement = RiskConstantsService.RiskMovement;
    this.consequenceMaster = RiskConstantsService.Consequence;
    this.severityMaster = RiskConstantsService.PeopleSeverity;
    this.environmentMaster = RiskConstantsService.EnvironmentSeverity;
    this.assetsMaster = RiskConstantsService.AssetsSeverity;
    this.reputationMaster = RiskConstantsService.ReputationSeverity;
    this.NPTMaster = RiskConstantsService.NPTSeverity;
    this.displayErrorMessage = new RaiseRiskShowErrorMessages();
    this.moduleId = ConstantsService.PermissionMatrixModules.Risk;
    this.actionList = [];
    this.addAction();
    this.baseService.translatorListener.subscribe(data => {
      this.translate.use(data);
    });
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    this.disableRisk = false;
    if (this.sourceId !== 0 && this.sourceId) {
      
      this.IsNewRecord = false;
      
    }
  }
  callbackMethodForUnitDetails(response: { Success: any; Result: any[]; }) {
    if (response.Success) {
      this.unitList = response.Result;
      const apiRequest = {
        Model: {
          GetActiveNodes: this.IsNewRecord,
          UserId: this.loggedInUserJSON.UserId
        }
      };
      this.masterscreenService.getTreeData(
        apiRequest,
        this.callbackMethodForGetTreeData.bind(this)
      );
    }
  }
  getTexts(color, Pear) {
    if (Pear === "People") {
      if (color === "riskColorRed") {
        return "High";
      } else if (color === "riskColorYellow") {
        return "Medium";
      } else if (color === "riskColorBlue") {
        return "Low";
      }
    } else if ("Environment") {
      if (color === "riskColorRed") {
        return "High";
      } else if (color === "riskColorYellow") {
        return "Medium";
      } else if (color === "riskColorBlue") {
        return "Low";
      }
    } else if ("Assets") {
      if (color === "riskColorRed") {
        return "High";
      } else if (color === "riskColorYellow") {
        return "Medium";
      } else if (color === "riskColorBlue") {
        return "Low";
      }
    } else if ("Reputation") {
      if (color === "riskColorRed") {
        return "High";
      } else if (color === "riskColorYellow") {
        return "Medium";
      } else if (color === "riskColorBlue") {
        return "Low";
      }
    }
  }
  getTextClass(colorClass) {
    switch (colorClass) {
      case "riskColorBlue":
        return "text-white";
      case "riskColorYellow":
        return "text-black";
      case "riskColorRed":
        return "text-white";
    }
  }
  getPermissionDetails(unitId: number) {
    this.baseService.showRootLoader = true;
    this.userPermissions.ModuleId =
      ConstantsService.PermissionMatrixModules.Risk;
    this.userPermissions.UserId = this.loggedInUserJSON.UserId;
    this.userPermissions.UnitId = unitId;
    const apiRequest = {
      Model: this.userPermissions
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForgetPermissionDetails.bind(this)
    );
  }

  callbackMethodForgetPermissionDetails(response: { Result: any; }) {
    const permissions = response.Result;
    if (response.Result) {
      this.riskPermission = permissions.RiskPermission;
      if (!this.riskPermission.RSK_Add && !this.riskPermission.RSK_Add_Unit && !this.riskPermission.RSK_Admin && !this.riskPermission.RSK_Admin_Unit) {
        this.routesFlag.find(s => s.routeName == RiskConstantsService.RiskRequest.RaiseRisk).isClickable = false;
      }
      if (
        !this.riskPermission.RSK_Admin &&
        !this.riskPermission.RSK_Admin_Unit &&
        !this.riskPermission.RSK_Own
      ) {
        this.disableRisk = true;
      }
      if (
        this.selectedRiskRequestId === 0 &&
        (this.riskPermission.RSK_Add || this.riskPermission.RSK_Add_Unit)
      ) {
        this.disableRisk = false;
      }
      if (
        this.selectedRiskRequestId > 0 &&
        (this.riskRequest.Status === "Cancelled" ||
          this.riskRequest.Status === "Deleted")
      ) {
        this.disableRisk = true;
      }
    }
    this.baseService.showRootLoader = false;
  }
  getRiskRequestForEdit() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        RiskRequestId: this.selectedRiskRequestId
      }
    };
    this.riskService.getRiskRequestForEdit(
      apiRequest,
      this.successGetRiskRequestForEdit.bind(this)
    );
  }
  RSKOwner:boolean = false;
  successGetRiskRequestForEdit(response: { Result: { RiskRequest: RiskRequest; ActionDetails: string | any[]; }; }) {
    if (this.loggedInUserJSON.UserTypes.UserType ===
      ObservationConstantsService.RequestFor.Contractor && response.Result.RiskRequest.RaisedBy != this.loggedInUserJSON.UserId
   ) {
     this.notificationsService.toastNotify(
       "error",
       "Warning Message",
       "This Risk not raised by you, you don't have permission to view this record...!"
     );  
     this.router.navigate(["risk/risk-overview"]);
     return ;
   }
    if (response.Result && response.Result.RiskRequest) {
      this.riskRequest = response.Result.RiskRequest;
      this.isActive =  this.riskRequest.Status == "New" ? true : false;
      this.riskPermission.RSK_Own =
        this.riskRequest.RaisedBy === this.loggedInUserJSON.UserId
          ? true
          : false;
          this.RSKOwner =
          this.riskRequest.RaisedBy === this.loggedInUserJSON.UserId
            ? true
            : false;
      this.unitTree.forEach(element => {
        this.compareTreeNode(element, this.riskRequest.UnitId);
      });
      this.isEmployeeUnit=true;
      if(this.selectedUnit.UnitTypeId == 2)
      {
        this.isEmployeeUnit=false;
        this.getContractDetails(this.selectedUnit.UnitId);
      }
      this.selectedContractId=this.riskRequest.ContractId;
      this.getPermissionDetails(this.riskRequest.UnitId);
      this.getIsActiveUnit(this.riskRequest.UnitId);
      this.riskLoaded = true;
      response.Result.RiskRequest.PotentialPEARList.forEach((potential: { RiskPear: string | String; RiskLikelihood: String; RiskSeverity: number; }) => {
        if (potential.RiskPear === "People") {
          const tempPear = new PeopleRisk();
          tempPear.PeopleRiskPear = potential.RiskPear;
          tempPear.PeopleRiskLikelihood = potential.RiskLikelihood;
          tempPear.PeopleRiskSeverity = potential.RiskSeverity;
          this.PotentialPeopleRisk = tempPear;
          this.PotentialPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
            tempPear.PeopleRiskSeverity,
            tempPear.PeopleRiskLikelihood
          );
          this.PotentialPeopleRisk.PeopleSelected = true;
        }
        if (potential.RiskPear === "Assets") {
          const tempPear = new AssetsRisk();
          tempPear.AssetsRiskPear = potential.RiskPear;
          tempPear.AssetsRiskLikelihood = potential.RiskLikelihood;
          tempPear.AssetsRiskSeverity = potential.RiskSeverity;
          this.PotentialAssetsRisk = tempPear;
          this.PotentialAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
            tempPear.AssetsRiskSeverity,
            tempPear.AssetsRiskLikelihood
          );
          this.PotentialAssetsRisk.AssetsSelected = true;
        }
        if (potential.RiskPear === "Environment") {
          const tempPear = new EnvironmentRisk();
          tempPear.EnvironmentRiskPear = potential.RiskPear;
          tempPear.EnvironmentRiskLikelihood = potential.RiskLikelihood;
          tempPear.EnvironmentRiskSeverity = potential.RiskSeverity;
          this.PotentialEnvironmentRisk = tempPear;
          this.PotentialEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
            tempPear.EnvironmentRiskSeverity,
            tempPear.EnvironmentRiskLikelihood
          );
          this.PotentialEnvironmentRisk.EnvironmentSelected = true;
        }
        if (potential.RiskPear === "Reputation") {
          const tempPear = new ReputationRisk();
          tempPear.ReputationRiskPear = potential.RiskPear;
          tempPear.ReputationRiskLikelihood = potential.RiskLikelihood;
          tempPear.ReputationRiskSeverity = potential.RiskSeverity;
          this.PotentialReputationRisk = tempPear;
          this.PotentialReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
            tempPear.ReputationRiskSeverity,
            tempPear.ReputationRiskLikelihood
          );
          this.PotentialReputationRisk.ReputationSelected = true;
        }
        if (potential.RiskPear === "NPT") {
          const tempPear = new NPTRisk();
          tempPear.NPTRiskPear = potential.RiskPear;
          tempPear.NPTRiskLikelihood = potential.RiskLikelihood;
          tempPear.NPTRiskSeverity = potential.RiskSeverity;
          this.PotentialNPTRisk = tempPear;
          this.PotentialNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
            tempPear.NPTRiskSeverity,
            tempPear.NPTRiskLikelihood
          );
          this.PotentialNPTRisk.NPTSelected = true;
        }
      });
      //Residual Pear
      response.Result.RiskRequest.ResidualPEARList.forEach((residual: { RiskPear: string | String; RiskLikelihood: String; RiskSeverity: number; }) => {
        if (residual.RiskPear === "People") {
          const tempPear = new PeopleRisk();
          tempPear.PeopleRiskPear = residual.RiskPear;
          tempPear.PeopleRiskLikelihood = residual.RiskLikelihood;
          tempPear.PeopleRiskSeverity = residual.RiskSeverity;
          this.ResidualPeopleRisk = tempPear;
          this.ResidualPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
            tempPear.PeopleRiskSeverity,
            tempPear.PeopleRiskLikelihood
          );
          this.ResidualPeopleRisk.PeopleSelected = true;
        }
        if (residual.RiskPear === "Assets") {
          const tempPear = new AssetsRisk();
          tempPear.AssetsRiskPear = residual.RiskPear;
          tempPear.AssetsRiskLikelihood = residual.RiskLikelihood;
          tempPear.AssetsRiskSeverity = residual.RiskSeverity;
          this.ResidualAssetsRisk = tempPear;
          this.ResidualAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
            tempPear.AssetsRiskSeverity,
            tempPear.AssetsRiskLikelihood
          );
          this.ResidualAssetsRisk.AssetsSelected = true;
        }
        if (residual.RiskPear === "Environment") {
          const tempPear = new EnvironmentRisk();
          tempPear.EnvironmentRiskPear = residual.RiskPear;
          tempPear.EnvironmentRiskLikelihood = residual.RiskLikelihood;
          tempPear.EnvironmentRiskSeverity = residual.RiskSeverity;
          this.ResidualEnvironmentRisk = tempPear;
          this.ResidualEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
            tempPear.EnvironmentRiskSeverity,
            tempPear.EnvironmentRiskLikelihood
          );
          this.ResidualEnvironmentRisk.EnvironmentSelected = true;
        }
        if (residual.RiskPear === "Reputation") {
          const tempPear = new ReputationRisk();
          tempPear.ReputationRiskPear = residual.RiskPear;
          tempPear.ReputationRiskLikelihood = residual.RiskLikelihood;
          tempPear.ReputationRiskSeverity = residual.RiskSeverity;
          this.ResidualReputationRisk = tempPear;
          this.ResidualReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
            tempPear.ReputationRiskSeverity,
            tempPear.ReputationRiskLikelihood
          );
          this.ResidualReputationRisk.ReputationSelected = true;
        }
        if (residual.RiskPear === "NPT") {
          const tempPear = new NPTRisk();
          tempPear.NPTRiskPear = residual.RiskPear;
          tempPear.NPTRiskLikelihood = residual.RiskLikelihood;
          tempPear.NPTRiskSeverity = residual.RiskSeverity;
          this.ResidualNPTRisk = tempPear;
          this.ResidualNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
            tempPear.NPTRiskSeverity,
            tempPear.NPTRiskLikelihood
          );
          this.ResidualNPTRisk.NPTSelected = true;
        }
      });
      //Assessment Pear
      response.Result.RiskRequest.RiskAssessmentPEARList.forEach((assessment: { RiskPear: string | String; RiskLikelihood: String; RiskSeverity: number; }) => {
        if (assessment.RiskPear === "People") {
          const tempPear = new PeopleRisk();
          tempPear.PeopleRiskPear = assessment.RiskPear;
          tempPear.PeopleRiskLikelihood = assessment.RiskLikelihood;
          tempPear.PeopleRiskSeverity = assessment.RiskSeverity;
          this.RiskassessmentPeople = tempPear;
          this.RiskassessmentPeople.PeopleRiskColor = this.riskService.getRiskColorClass(
            tempPear.PeopleRiskSeverity,
            tempPear.PeopleRiskLikelihood
          );
          this.RiskassessmentPeople.PeopleSelected = true;
        }
        if (assessment.RiskPear === "Assets") {
          const tempPear = new AssetsRisk();
          tempPear.AssetsRiskPear = assessment.RiskPear;
          tempPear.AssetsRiskLikelihood = assessment.RiskLikelihood;
          tempPear.AssetsRiskSeverity = assessment.RiskSeverity;
          this.RiskassessmentAssets = tempPear;
          this.RiskassessmentAssets.AssetsRiskColor = this.riskService.getRiskColorClass(
            tempPear.AssetsRiskSeverity,
            tempPear.AssetsRiskLikelihood
          );
          this.RiskassessmentAssets.AssetsSelected = true;
        }
        if (assessment.RiskPear === "Environment") {
          const tempPear = new EnvironmentRisk();
          tempPear.EnvironmentRiskPear = assessment.RiskPear;
          tempPear.EnvironmentRiskLikelihood = assessment.RiskLikelihood;
          tempPear.EnvironmentRiskSeverity = assessment.RiskSeverity;
          this.RiskassessmentEnvironment = tempPear;
          this.RiskassessmentEnvironment.EnvironmentRiskColor = this.riskService.getRiskColorClass(
            tempPear.EnvironmentRiskSeverity,
            tempPear.EnvironmentRiskLikelihood
          );
          this.RiskassessmentEnvironment.EnvironmentSelected = true;
        }
        if (assessment.RiskPear === "Reputation") {
          const tempPear = new ReputationRisk();
          tempPear.ReputationRiskPear = assessment.RiskPear;
          tempPear.ReputationRiskLikelihood = assessment.RiskLikelihood;
          tempPear.ReputationRiskSeverity = assessment.RiskSeverity;
          this.RiskassessmentReputation = tempPear;
          this.RiskassessmentReputation.ReputationRiskColor = this.riskService.getRiskColorClass(
            tempPear.ReputationRiskSeverity,
            tempPear.ReputationRiskLikelihood
          );
          this.RiskassessmentReputation.ReputationSelected = true;
        }
        if (assessment.RiskPear === "NPT") {
          const tempPear = new NPTRisk();
          tempPear.NPTRiskPear = assessment.RiskPear;
          tempPear.NPTRiskLikelihood = assessment.RiskLikelihood;
          tempPear.NPTRiskSeverity = assessment.RiskSeverity;
          this.RiskassessmentNPT = tempPear;
          this.RiskassessmentNPT.NPTRiskColor = this.riskService.getRiskColorClass(
            tempPear.NPTRiskSeverity,
            tempPear.NPTRiskLikelihood
          );
          this.RiskassessmentNPT.NPTSelected = true;
        }
      });
      if (response.Result.ActionDetails.length > 0) {
        this.actionList = response.Result.ActionDetails;
        this.actionList.forEach((element: any) => {
          element.TargetDate = moment(
            moment.utc(element.TargetDate).local()
          ).toDate();
        });
        for (let index = 0; index < this.actionList.length; index++) {
          this.ref.detectChanges();
          this.actionList[index].FilesPreview = this.actionList[index].Files;
          this.actionList[index].Files = this.actionList[index].Files;
        }
      } else {
        this.actionList = [];
        this.addAction();
      }
    }
   this.getSpecificationData(this.riskRequest.RiskRequestId);
    this.riskService.setupdatedRiskData(JSON.stringify(this.riskRequest));
    this.riskIds = this.riskService.getAllRiskIds();
    let currentIndex: number = 0;
    this.riskIds.forEach((element, index) => {
      if (element === this.selectedRiskRequestId) {
        currentIndex = index;
        return;
      }
    });
    if (currentIndex === 0) {
      this.isPrevious = false;
    }
    if (currentIndex === this.riskIds.length - 1) {
      this.isNext = false;
    }
    this.baseService.showRootLoader = false;
  }


  getSpecificationData(RiskRequestId : number) {
		const apiRequest = {
			Model: {
				SourceId: RiskRequestId,
				ModuleId: ConstantsService.PermissionMatrixModules.Risk
			}
		};
		this.commonService.getCategoryData(apiRequest, this.callbackMethodForGetSpecificationData.bind(this));
	}

	callbackMethodForGetSpecificationData(response) {
		this.lifeSavingCheckedValue = [];
	//	this.resetCategoryData();
		if (response && response.Success) {
			this.specificationResponseData = response.Result;
			if (this.specificationResponseData.ModuleId === this.moduleId && this.specificationResponseData.SourceId === this.sourceId) {
				this.isShowSpecification = true;
				this.isShowCategory = false;
				this.specificationResponseData.RuleId.forEach(checkedrule => {
					for (var i = 0; i < this.specificationData.length; i++) {
						for (var j = 0; j < this.specificationData[i].LstCategoryRuleGroupedByCategoryId.length; j++) {
							if (this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].RuleId === checkedrule) {
								this.specificationData[i].LstCategoryRuleGroupedByCategoryId[j].Checked = true;
								this.lifeSavingCheckedValue.push(checkedrule);
							}
						}
					}
				});
			}
		//	this.categoryCheckedValueEmittedData.emit(this.lifeSavingCheckedValue);
		}
	}



  getAllMasterForRaiseRisk() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        CompanyId: this.loggedInUserJSON.Company.CompanyId
      }
    };
    this.riskService.getAllMasterForRaiseRisk(
      apiRequest,
      this.getAllMasterForRaiseRiskSuccess.bind(this)
    );
  }

  getAllMasterForRaiseRiskSuccess(response: { Result: RaiseRiskAllMaster; }) {
    this.raiseRiskAllMaster = response.Result;
    this.baseService.showRootLoader = false;
    if (this.sourceId > 0) {
     
      this.getRiskRequestForEdit();
    }
    
  }

  // To get Employee(s) and Contractor(s) name
  getUsersOnSearch(event: { query: string; }) {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = event.query;
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = this.selectedUnit.UnitId;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.riskService.getSearchResultsForUsers(
      apiRequest,
      this.callbackMethodForGetSearchResultsForUsersData.bind(this)
    );
  }
  // call back method of employee on search
  callbackMethodForGetSearchResultsForUsersData(response: { Success: any; Result: string | any[]; }) {
    if (response.Success) {
      const filtered: any[] = [];
      for (let index = 0; index < response.Result.length; index++) {
        const user = response.Result[index];
        if (
          user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(user);
        }
      }
      this.userResults = filtered;
    }
  }
  getRiskColor(selectedType: any, TypeOfCategory: any) {
    switch (selectedType) {
      case RiskConstantsService.RiskType.Potential:
        switch (TypeOfCategory) {
          case "People":
            this.PotentialPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
              this.PotentialPeopleRisk.PeopleRiskSeverity,
              this.PotentialPeopleRisk.PeopleRiskLikelihood
            );
            break;
          case "Assets":
            this.PotentialAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
              this.PotentialAssetsRisk.AssetsRiskSeverity,
              this.PotentialAssetsRisk.AssetsRiskLikelihood
            );
            break;
          case "Environment":
            this.PotentialEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
              this.PotentialEnvironmentRisk.EnvironmentRiskSeverity,
              this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood
            );
            break;
          case "Reputation":
            this.PotentialReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
              this.PotentialReputationRisk.ReputationRiskSeverity,
              this.PotentialReputationRisk.ReputationRiskLikelihood
            );
            break;
          case "NPT":
            this.PotentialNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
              this.PotentialNPTRisk.NPTRiskSeverity,
              this.PotentialNPTRisk.NPTRiskLikelihood
            );
            break;
        }
        break;
      case RiskConstantsService.RiskType.Residual:
        this.residualRiskColor = this.riskService.getRiskColorClass(
          this.riskRequest.ResidualRiskSeverity,
          this.riskRequest.ResidualRiskLikelihood
        );
        break;
    }
  }
  getRiskColor1(selectedType: any, TypeOfCategory: any) {
    switch (selectedType) {
      case RiskConstantsService.RiskType.Residual:
        switch (TypeOfCategory) {
          case "People":
            this.ResidualPeopleRisk.PeopleRiskColor = this.riskService.getRiskColorClass(
              this.ResidualPeopleRisk.PeopleRiskSeverity,
              this.ResidualPeopleRisk.PeopleRiskLikelihood
            );
            break;
          case "Assets":
            this.ResidualAssetsRisk.AssetsRiskColor = this.riskService.getRiskColorClass(
              this.ResidualAssetsRisk.AssetsRiskSeverity,
              this.ResidualAssetsRisk.AssetsRiskLikelihood
            );
            break;
          case "Environment":
            this.ResidualEnvironmentRisk.EnvironmentRiskColor = this.riskService.getRiskColorClass(
              this.ResidualEnvironmentRisk.EnvironmentRiskSeverity,
              this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood
            );
            break;
          case "Reputation":
            this.ResidualReputationRisk.ReputationRiskColor = this.riskService.getRiskColorClass(
              this.ResidualReputationRisk.ReputationRiskSeverity,
              this.ResidualReputationRisk.ReputationRiskLikelihood
            );
            break;
          case "NPT":
            this.ResidualNPTRisk.NPTRiskColor = this.riskService.getRiskColorClass(
              this.ResidualNPTRisk.NPTRiskSeverity,
              this.ResidualNPTRisk.NPTRiskLikelihood
            );
            break;
        }
        break;
      case RiskConstantsService.RiskType.Potential:
        this.potentialRiskColor = this.riskService.getRiskColorClass(
          this.riskRequest.ResidualRiskSeverity,
          this.riskRequest.ResidualRiskLikelihood
        );
        break;
    }
  }

  getRiskAssessmentColor(selectedType: any, TypeOfCategory: any) {
    switch (selectedType) {
      case RiskConstantsService.RiskType.Residual:
        switch (TypeOfCategory) {
          case "People":
            this.RiskassessmentPeople.PeopleRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentPeople.PeopleRiskSeverity,
              this.RiskassessmentPeople.PeopleRiskLikelihood
            );
            break;
          case "Assets":
            this.RiskassessmentAssets.AssetsRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentAssets.AssetsRiskSeverity,
              this.RiskassessmentAssets.AssetsRiskLikelihood
            );
            break;
          case "Environment":
            this.RiskassessmentEnvironment.EnvironmentRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentEnvironment.EnvironmentRiskSeverity,
              this.RiskassessmentEnvironment.EnvironmentRiskLikelihood
            );
            break;
          case "Reputation":
            this.RiskassessmentReputation.ReputationRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentReputation.ReputationRiskSeverity,
              this.RiskassessmentReputation.ReputationRiskLikelihood
            );
            break;
          case "NPT":
            this.RiskassessmentNPT.NPTRiskColor = this.riskService.getRiskColorClass(
              this.RiskassessmentNPT.NPTRiskSeverity,
              this.RiskassessmentNPT.NPTRiskLikelihood
            );
            break;
        }
        break;
      case RiskConstantsService.RiskType.Potential:
        this.potentialRiskColor = this.riskService.getRiskColorClass(
          this.riskRequest.ResidualRiskSeverity,
          this.riskRequest.ResidualRiskLikelihood
        );
        break;
    }
  }
  removeActionFromActionList(index: number) {
    if (this.actionList.length > 1) {
      this.actionList.splice(index, 1);
    }
  }
  addAction() {
    this.actionPost = new AssignActionPost();
    this.actionList.push(this.actionPost);
  }
  raiseRisks() {
    if (this.validateForm()) {
      const raiseRisk = new RaiseRisk();
      this.baseService.showRootLoader = true;
      this.bindActionOwnerIdToList();
      this.createPEARList();
      this.raiseRisk.RiskRequest.UnitId = parseInt(this.selectedUnit.UnitId);
      this.raiseRisk.RiskRequest.IsDraft = false;
      this.raiseRisk.RiskRequest.ContractId  = this.isEmployeeUnit?0: this.selectedContractId;
      this.raiseRisk.RiskRequest.RiskId = this.selectedRiskRequestId;

      const apiRequest = {
        Model: this.raiseRisk
      };
      this.riskService.raiseRisk(apiRequest, this.raiseRiskSuccess.bind(this));
    }
    else {
      this.baseService.showRootLoader = false;
    }
  }
  bindActionOwnerIdToList() {
    if (this.riskPermission.RSK_Admin || this.riskPermission.RSK_Admin_Unit) {
      this.actionList.forEach((action: { ActionPartyId: any; selectedActionParty: { UserId: any; }; ActionOwnerId: any; ActionOwner: { UserId: any; }; UnitId: number; }) => {
        action.ActionPartyId = action.selectedActionParty.UserId;
        action.ActionOwnerId = action.ActionOwner.UserId;
        action.UnitId = parseInt(this.selectedUnit);
      });
    }
  }
  selectActionOwner(event: { UserId: any; FullName: any; Email: any; FirstName: any; LastName: any; UserTypeId: any; UserTypes: any; ContactNumber: any; Designation: any; DepartmentName: any; }, index: string | number) {
    if (!event.UserId) {
      this.actionList[index].ActionOwner.UserId = 0;
    } else {
      this.actionList[index].selectedActionParty = new User();
      // this.actionList[index].selectedActionParty = {
      //   UserId: event.UserId,
      //   FullName: event.FullName,
      //   Email: event.Email,
      //   FirstName: event.FirstName,
      //   LastName: event.LastName,
      //   UserTypeId: event.UserTypeId,
      //   UserTypes: event.UserTypes,
      //   ContactNumber: event.ContactNumber,
      //   Designation: event.Designation,
      //   DepartmentName: event.DepartmentName
      // };
      this.actionList[index].ShowActionOwnerErrorMessage = false;
    }
  }
  getIsActiveUnit(unitId) {
    
    const apiRequestUnit = {
      Model: {
        UnitId: unitId,  
      },
    };
    this.masterscreenService.getIsActiveUnit(
      apiRequestUnit,
      this.callbackMethodForgetIsActiveUnit.bind(this)
    );
  }

  callbackMethodForgetIsActiveUnit(response) {

    this.editEnabled = response.Result[0].IsActive;
    
  }
  selectActionParty(event: { UserId: any; }, index: string | number) {
    if (!event.UserId) {
      this.actionList[index].ActionParty.UserId = 0;
    } else {
      this.actionList[index].ShowActionPartyErrorMessage = false;
    }
  }
  raiseRiskSuccess(response: { Success: any; Result: number; Errors: null; }) {
    if (response && response.Success) {
      if (this.riskRequest.RiskRequestId === 0) {
        this.raiseRisk.RiskRequest.RiskRequestId = response.Result;
        this.trackDetails(this.raiseRisk);
      }
      // reset form fields
      this.resetForm();
      // show success message
      // this.alertType = ConstantsService.Success;
      // this.successDetails = 'Risk details has been added successfully';
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Risk details has been added successfully"
      );
      this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
      this.savePDF(response.Result);
      if (this.lifeSavingCheckedValueData.length > 0) {
        this.submitSpecificationData();
      }
    }
    if (response.Errors !== null) {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong."
      );
      // this.alertType = ConstantsService.Error;
      // this.errorDetails = response.Errors;
    }
    this.baseService.showRootLoader = false;
  }

  onYesClickedSuccess() {
    switch (this.alertFrom) {
      case "RaiseUpdate":
        this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
        break;
    }
    this.alertType = "";
    this.errorDetails = null;
    this.successDetails = "";
  }

  validateForm() {
    this.baseService.showRootLoader = true;
    let isFormValid = true;
    this.unitError = true;
    if (this.selectedUnit != undefined) {
    if (this.selectedUnit.UnitId) {

      this.unitError = false;

      isFormValid = true;

    }
    }
    if (
      this.riskRequest.RiskSourceId === 0 ||
      this.riskRequest.RiskSourceId.toString() === "0"
    ) {
      this.displayErrorMessage.showRiskSourceErrorMessage = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.ProjectId === 0 ||
      this.riskRequest.ProjectId.toString() === "0"
    ) {
      this.displayErrorMessage.showProjectNameErrorMessage = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.LocationId === 0 ||
      this.riskRequest.LocationId.toString() === "0"
    ) {
      this.displayErrorMessage.showLocationErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.RiskTitle.trim() === "") {
      this.displayErrorMessage.showRiskTitleErrorMessage = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.RiskManagementToolId === 0 ||
      this.riskRequest.RiskManagementToolId.toString() === "0"
    ) {
      this.displayErrorMessage.showRiskManagementToolErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ActivityLeadingToHazard.trim() === "") {
      this.displayErrorMessage.showActivityLeadingToHazardErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.HazardIdentified.trim() === "") {
      this.displayErrorMessage.showHazardIdentifiedErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ThreatIdentified.trim() === "") {
      this.displayErrorMessage.showThreatIdentifiedErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.Consequences.trim() === "") {
      this.displayErrorMessage.showConsequencesErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.PotentialRiskPear.trim() === "0") {
      this.displayErrorMessage.showPotentialPearErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.PotentialRiskLikelihood.trim() === "0") {
      this.displayErrorMessage.showPotentialConsequencesErrorMessage = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.PotentialRiskSeverity === 0 ||
      this.riskRequest.PotentialRiskSeverity.toString() === "0"
    ) {
      this.displayErrorMessage.showPotentialSeverityErrorMessage = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.RiskControlTechniquesId === 0 ||
      this.riskRequest.RiskControlTechniquesId.toString() === "0"
    ) {
      this.displayErrorMessage.showControlTechniqueErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ControlMeasure.trim() === "") {
      this.displayErrorMessage.showControlMeasureErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ContengencyPlan.trim() === "") {
      this.displayErrorMessage.showContegencyPlanErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ResidualRiskPear.trim() === "0") {
      this.displayErrorMessage.showResidualPearErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.ResidualRiskLikelihood.trim() === "0") {
      this.displayErrorMessage.showResidualConsequenceErrorMessage = true;
      isFormValid = false;
    }
    if (
      this.riskRequest.ResidualRiskSeverity === 0 ||
      this.riskRequest.ResidualRiskSeverity.toString() === "0"
    ) {
      this.displayErrorMessage.showResidualSeverityErrorMessage = true;
      isFormValid = false;
    }
    if (this.riskRequest.RiskMovement.trim() === "0") {
      this.displayErrorMessage.showResidualRiskMovementErrorMessage = true;
      isFormValid = false;
    }
    // //validation messages for Potential PEAR
    // if (this.riskPermission.RSK_PotentialRiskIdentified_Edit || this.riskPermission.RSK_PotentialRiskIdentified_Edit_Unit) {
    //   if (this.PotentialPeopleRisk.PeopleRiskSeverity === 0 || this.PotentialPeopleRisk.PeopleRiskSeverity.toString() === '0') {
    //     this.ShowPeopleSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialPeopleRisk.PeopleRiskLikelihood.trim() === '0') {
    //     this.ShowPeopleLikelihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialEnvironmentRisk.EnvironmentRiskSeverity === 0 || this.PotentialEnvironmentRisk.EnvironmentRiskSeverity.toString() === '0') {
    //     this.ShowEnvironmentSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood.trim() === '0') {
    //     this.ShowEnvironmentlihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialAssetsRisk.AssetsRiskSeverity === 0 || this.PotentialAssetsRisk.AssetsRiskSeverity.toString() === '0') {
    //     this.ShowAssetsSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialAssetsRisk.AssetsRiskLikelihood.trim() === '0') {
    //     this.ShowAssetslihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialReputationRisk.ReputationRiskSeverity === 0 || this.PotentialReputationRisk.ReputationRiskSeverity.toString() === '0') {
    //     this.ShowReputationSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.PotentialReputationRisk.ReputationRiskLikelihood.trim() === '0') {
    //     this.ShowReputationlihooodMessage = true;
    //     isFormValid = false;
    //   }
    // }
    // //validation messages for residual PEAR
    // if (this.riskPermission.RSK_ResidualRiskIdentified_Edit || this.riskPermission.RSK_ResidualRiskIdentified_Edit_Unit) {
    //   if (this.ResidualPeopleRisk.PeopleRiskSeverity === 0 || this.ResidualPeopleRisk.PeopleRiskSeverity.toString() === '0') {
    //     this.residualPeopleSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualPeopleRisk.PeopleRiskLikelihood.trim() === '0') {
    //     this.residualPeopleLikelihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualEnvironmentRisk.EnvironmentRiskSeverity === 0 || this.ResidualEnvironmentRisk.EnvironmentRiskSeverity.toString() === '0') {
    //     this.residualEnvironmentSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood.trim() === '0') {
    //     this.residualEnvironmentlihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualAssetsRisk.AssetsRiskSeverity === 0 || this.ResidualAssetsRisk.AssetsRiskSeverity.toString() === '0') {
    //     this.residualAssetsSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualAssetsRisk.AssetsRiskLikelihood.trim() === '0') {
    //     this.residualAssetslihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualReputationRisk.ReputationRiskSeverity === 0 || this.ResidualReputationRisk.ReputationRiskSeverity.toString() === '0') {
    //     this.residualReputationSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.ResidualReputationRisk.ReputationRiskLikelihood.trim() === '0') {
    //     this.residualReputationlihooodMessage = true;
    //     isFormValid = false;
    //   }
    // }
    // //validation messages for Assessment PEAR
    // if (this.riskPermission.RSK_CurrentRiskAssessment_Identified_Edit || this.riskPermission.RSK_CurrentRiskAssessment_Identified_Edit_Unit) {
    //   if (this.RiskassessmentPeople.PeopleRiskSeverity === 0 || this.RiskassessmentPeople.PeopleRiskSeverity.toString() === '0') {
    //     this.assessmentPeopleSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentPeople.PeopleRiskLikelihood.trim() === '0') {
    //     this.assessmentPeopleLikelihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentEnvironment.EnvironmentRiskSeverity === 0 || this.RiskassessmentEnvironment.EnvironmentRiskSeverity.toString() === '0') {
    //     this.assessmentEnvironmentSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentEnvironment.EnvironmentRiskLikelihood.trim() === '0') {
    //     this.assessmentEnvironmentlihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentAssets.AssetsRiskSeverity === 0 || this.RiskassessmentAssets.AssetsRiskSeverity.toString() === '0') {
    //     this.assessmentAssetsSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentAssets.AssetsRiskLikelihood.trim() === '0') {
    //     this.assessmentAssetslihooodMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentReputation.ReputationRiskSeverity === 0 || this.RiskassessmentReputation.ReputationRiskSeverity.toString() === '0') {
    //     this.assessmentReputationSeverityMessage = true;
    //     isFormValid = false;
    //   }
    //   if (this.RiskassessmentReputation.ReputationRiskLikelihood.trim() === '0') {
    //     this.assessmentReputationlihooodMessage = true;
    //     isFormValid = false;
    //   }
    // }
    // Action error messages
    if (this.riskPermission.RSK_Admin || this.riskPermission.RSK_Admin_Unit) {
      if (this.actionList[0].Action !== "") {
        this.actionList.forEach((action: { Action: string; ShowActionErrorMessage: boolean; ActionOwner: { UserId: number; }; ShowActionOwnerErrorMessage: boolean; selectedActionParty: { UserId: number; }; ShowActionPartyErrorMessage: boolean; Priority: number; ShowPriorityErrorMessage: boolean; TargetDate: any; ShowTargetErrorMessage: boolean; }) => {
          if (action.Action.trim() === "") {
            action.ShowActionErrorMessage = true;
            isFormValid = false;
          }
          if (action.ActionOwner.UserId == 0) {
            action.ShowActionOwnerErrorMessage = true;
            isFormValid = false;
          }
          if (action.selectedActionParty.UserId == 0) {
            action.ShowActionPartyErrorMessage = true;
            isFormValid = false;
          }
          if (action.Priority === 0) {
            action.ShowPriorityErrorMessage = true;
            isFormValid = false;
          }
          if (!action.TargetDate) {
            action.ShowTargetErrorMessage = true;
            isFormValid = false;
          }
        });
      }
    }
    return isFormValid;
  }
  confirmResetForm() {
    this.alertType = ConstantsService.Confirm;
    this.confirmMessage =
      "You have clicked reset button. All information " +
      "entered by you on this page will be lost. Do you want to reset the form?";
  }
  onYesClickedForConfirmation() {
    this.resetForm();
    this.alertType = "";
    this.confirmMessage = "";
  }
  onNoClickedForConfirmation() {
    this.alertType = "";
    this.confirmMessage = "";
  }
  resetForm() {
    this.displayErrorMessage = new RaiseRiskShowErrorMessages();
    this.riskRequest = new RiskRequest();
    this.actionPost = new AssignActionPost();
    this.actionList = [];
    this.PotentialPeopleRisk = new PeopleRisk();
    this.PotentialEnvironmentRisk = new EnvironmentRisk();
    this.PotentialAssetsRisk = new AssetsRisk();
    this.PotentialReputationRisk = new ReputationRisk();
    this.PotentialNPTRisk = new NPTRisk();
    this.ResidualPeopleRisk = new PeopleRisk();
    this.ResidualAssetsRisk = new AssetsRisk();
    this.ResidualEnvironmentRisk = new EnvironmentRisk();
    this.ResidualReputationRisk = new ReputationRisk();
    this.ResidualNPTRisk = new NPTRisk();
    this.RiskassessmentPeople = new PeopleRisk();
    this.RiskassessmentEnvironment = new EnvironmentRisk();
    this.RiskassessmentAssets = new AssetsRisk();
    this.RiskassessmentReputation = new ReputationRisk();
    this.RiskassessmentReputation.ReputationSelected = false;
    this.RiskassessmentNPT = new NPTRisk();
    this.RiskassessmentNPT.NPTSelected = false;
    this.actionList.push(this.actionPost);
    this.searchTexts = new SearchText();
  }
  updateRisk() {
    if (this.validateForm()) {
      this.baseService.showRootLoader = true;
      const raiseRisk = new RaiseRisk();
      this.UpdatedPotentialPear = [];
      this.UpdatedResidualPear = [];
      this.UpdatedAssessmentPear = [];
      raiseRisk.RiskRequest = this.riskRequest;
     raiseRisk.RiskRequest.ContractId = this.isEmployeeUnit?0: this.selectedContractId;
      if (this.PotentialPeopleRisk) {
        const tempPear = new PearDetails();
        tempPear.RiskPear = this.PotentialPeopleRisk.PeopleRiskPear;
        tempPear.RiskSeverity = this.PotentialPeopleRisk.PeopleRiskSeverity;
        tempPear.RiskLikelihood = this.PotentialPeopleRisk.PeopleRiskLikelihood;
        this.UpdatedPotentialPear.push(tempPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
      }
      if (this.PotentialEnvironmentRisk) {
        const tempEnvironmentPear = new PearDetails();
        tempEnvironmentPear.RiskPear = this.PotentialEnvironmentRisk.EnvironmentRiskPear;
        tempEnvironmentPear.RiskSeverity = this.PotentialEnvironmentRisk.EnvironmentRiskSeverity;
        tempEnvironmentPear.RiskLikelihood = this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood;
        this.UpdatedPotentialPear.push(tempEnvironmentPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
      }
      if (this.PotentialAssetsRisk) {
        const tempAssetsPear = new PearDetails();
        tempAssetsPear.RiskPear = this.PotentialAssetsRisk.AssetsRiskPear;
        tempAssetsPear.RiskSeverity = this.PotentialAssetsRisk.AssetsRiskSeverity;
        tempAssetsPear.RiskLikelihood = this.PotentialAssetsRisk.AssetsRiskLikelihood;
        this.UpdatedPotentialPear.push(tempAssetsPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
      }
      if (this.PotentialReputationRisk) {
        const tempReputationPear = new PearDetails();
        tempReputationPear.RiskPear = this.PotentialReputationRisk.ReputationRiskPear;
        tempReputationPear.RiskSeverity = this.PotentialReputationRisk.ReputationRiskSeverity;
        tempReputationPear.RiskLikelihood = this.PotentialReputationRisk.ReputationRiskLikelihood;
        this.UpdatedPotentialPear.push(tempReputationPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
      }
      if (this.PotentialNPTRisk) {
        const tempNPTPear = new PearDetails();
        tempNPTPear.RiskPear = this.PotentialNPTRisk.NPTRiskPear;
        tempNPTPear.RiskSeverity = this.PotentialNPTRisk.NPTRiskSeverity;
        tempNPTPear.RiskLikelihood = this.PotentialNPTRisk.NPTRiskLikelihood;
        this.UpdatedPotentialPear.push(tempNPTPear);
        raiseRisk.PotentialPEARList = this.UpdatedPotentialPear;
      }
      if (this.ResidualPeopleRisk) {
        const residualPear = new PearDetails();
        residualPear.RiskPear = this.ResidualPeopleRisk.PeopleRiskPear;
        residualPear.RiskSeverity = this.ResidualPeopleRisk.PeopleRiskSeverity;
        residualPear.RiskLikelihood = this.ResidualPeopleRisk.PeopleRiskLikelihood;
        this.UpdatedResidualPear.push(residualPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
      }
      if (this.ResidualEnvironmentRisk) {
        const residualEnvPear = new PearDetails();
        residualEnvPear.RiskPear = this.ResidualEnvironmentRisk.EnvironmentRiskPear;
        residualEnvPear.RiskSeverity = this.ResidualEnvironmentRisk.EnvironmentRiskSeverity;
        residualEnvPear.RiskLikelihood = this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood;
        this.UpdatedResidualPear.push(residualEnvPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
      }
      if (this.ResidualAssetsRisk) {
        const residualAssetsPear = new PearDetails();
        residualAssetsPear.RiskPear = this.ResidualAssetsRisk.AssetsRiskPear;
        residualAssetsPear.RiskSeverity = this.ResidualAssetsRisk.AssetsRiskSeverity;
        residualAssetsPear.RiskLikelihood = this.ResidualAssetsRisk.AssetsRiskLikelihood;
        this.UpdatedResidualPear.push(residualAssetsPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
      }
      if (this.ResidualReputationRisk) {
        const residualReputationPear = new PearDetails();
        residualReputationPear.RiskPear = this.ResidualReputationRisk.ReputationRiskPear;
        residualReputationPear.RiskSeverity = this.ResidualReputationRisk.ReputationRiskSeverity;
        residualReputationPear.RiskLikelihood = this.ResidualReputationRisk.ReputationRiskLikelihood;
        this.UpdatedResidualPear.push(residualReputationPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
      }
      if (this.ResidualNPTRisk) {
        const residualNPTPear = new PearDetails();
        residualNPTPear.RiskPear = this.ResidualNPTRisk.NPTRiskPear;
        residualNPTPear.RiskSeverity = this.ResidualNPTRisk.NPTRiskSeverity;
        residualNPTPear.RiskLikelihood = this.ResidualNPTRisk.NPTRiskLikelihood;
        this.UpdatedResidualPear.push(residualNPTPear);
        raiseRisk.ResidualPEARList = this.UpdatedResidualPear;
      }
      if (this.RiskassessmentPeople) {
        const assessmentPear = new PearDetails();
        assessmentPear.RiskPear = this.RiskassessmentPeople.PeopleRiskPear;
        assessmentPear.RiskSeverity = this.RiskassessmentPeople.PeopleRiskSeverity;
        assessmentPear.RiskLikelihood = this.RiskassessmentPeople.PeopleRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
      }
      if (this.RiskassessmentEnvironment) {
        const assessmentEnvPear = new PearDetails();
        assessmentEnvPear.RiskPear = this.RiskassessmentEnvironment.EnvironmentRiskPear;
        assessmentEnvPear.RiskSeverity = this.RiskassessmentEnvironment.EnvironmentRiskSeverity;
        assessmentEnvPear.RiskLikelihood = this.RiskassessmentEnvironment.EnvironmentRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentEnvPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
      }
      if (this.RiskassessmentAssets) {
        const assessmentAssetsPear = new PearDetails();
        assessmentAssetsPear.RiskPear = this.RiskassessmentAssets.AssetsRiskPear;
        assessmentAssetsPear.RiskSeverity = this.RiskassessmentAssets.AssetsRiskSeverity;
        assessmentAssetsPear.RiskLikelihood = this.RiskassessmentAssets.AssetsRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentAssetsPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
      }
      if (this.RiskassessmentReputation) {
        const assessmentsReputationPear = new PearDetails();
        assessmentsReputationPear.RiskPear = this.RiskassessmentReputation.ReputationRiskPear;
        assessmentsReputationPear.RiskSeverity = this.RiskassessmentReputation.ReputationRiskSeverity;
        assessmentsReputationPear.RiskLikelihood = this.RiskassessmentReputation.ReputationRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentsReputationPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
      }
      if (this.RiskassessmentNPT) {
        const assessmentsNPTPear = new PearDetails();
        assessmentsNPTPear.RiskPear = this.RiskassessmentNPT.NPTRiskPear;
        assessmentsNPTPear.RiskSeverity = this.RiskassessmentNPT.NPTRiskSeverity;
        assessmentsNPTPear.RiskLikelihood = this.RiskassessmentNPT.NPTRiskLikelihood;
        this.UpdatedAssessmentPear.push(assessmentsNPTPear);
        raiseRisk.RiskAssessmentPEARList = this.UpdatedAssessmentPear;
      }
      raiseRisk.RiskRequest.UnitId = parseInt(this.selectedUnit.UnitId);
      this.trackDetails(raiseRisk);
      const apiRequest = {
        Model: raiseRisk
      };
      this.riskService.updateRisk(
        apiRequest,
        this.updateRiskSuccess.bind(this)
      );
    } else {
      this.baseService.showRootLoader = false;
      this.alertType = ConstantsService.Error;
      this.errorDetails = "Please fill all Mandatory fields.";
    }
  }

  updateRiskSuccess(response: { Result: any; }) {
    if (response && response.Result) {
      // show success message
      this.alertFrom = "RaiseUpdate";
      // this.alertType = ConstantsService.Success;
      // this.successDetails = 'Risk details has been updated successfully';
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Risk details has been updated successfully"
      );
      this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
      if (this.actionList.length > 0) {
        this.updateAction();
      }
      if (this.lifeSavingCheckedValueData.length > 0) {
        this.submitSpecificationData();
      }
      this.savePDF(this.riskRequest.RiskRequestId);
    }
    this.baseService.showRootLoader = false;
    
  }

  /**
   * Check the checkbox
   * @param RiskType : risk type i.e. Potential
   * @param Category : category type i.e. PEAR
   */
  selectPotentialSection(Checked: any, RiskType: any, Category: string) {
    switch (RiskType) {
      case RiskConstantsService.RiskType.Potential:
        if (Category === "People") {
          if (Checked) {
            this.PotentialPeopleRisk.PeopleSelected = true;
          } else {
            this.PotentialPeopleRisk.PeopleSelected = false;
            this.PotentialPeopleRisk = new PeopleRisk();
          }
        }
        if (Category === "Assets") {
          if (Checked) {
            this.PotentialAssetsRisk.AssetsSelected = true;
          } else {
            this.PotentialAssetsRisk.AssetsSelected = false;
            this.PotentialAssetsRisk = new AssetsRisk();
          }
        }
        if (Category === "Environment") {
          if (Checked) {
            this.PotentialEnvironmentRisk.EnvironmentSelected = true;
          } else {
            this.PotentialEnvironmentRisk.EnvironmentSelected = false;
            this.PotentialEnvironmentRisk = new EnvironmentRisk();
          }
        }
        if (Category === "Reputation") {
          if (Checked) {
            this.PotentialReputationRisk.ReputationSelected = true;
          } else {
            this.PotentialReputationRisk.ReputationSelected = false;
            this.PotentialReputationRisk = new ReputationRisk();
          }
        }
        if (Category === "NPT") {
          if (Checked) {
            this.PotentialNPTRisk.NPTSelected = true;
          } else {
            this.PotentialNPTRisk.NPTSelected = false;
            this.PotentialNPTRisk = new NPTRisk();
          }
        }
        break;
      case RiskConstantsService.RiskType.Residual:
        break;
    }
  }

  /**
   * Check the checkbox
   * @param RiskType : risk type i.e. Potential
   * @param Category : category type i.e. PEAR
   */
  selectResidualSection(Checked: any, RiskType: any, Category: string) {
    switch (RiskType) {
      case RiskConstantsService.RiskType.Residual:
        if (Category === "People") {
          if (Checked) {
            this.ResidualPeopleRisk.PeopleSelected = true;
          } else {
            this.ResidualPeopleRisk.PeopleSelected = false;
            this.ResidualPeopleRisk = new PeopleRisk();
          }
        }
        if (Category === "Assets") {
          if (Checked) {
            this.ResidualAssetsRisk.AssetsSelected = true;
          } else {
            this.ResidualAssetsRisk.AssetsSelected = false;
            this.ResidualAssetsRisk = new AssetsRisk();
          }
        }
        if (Category === "Environment") {
          if (Checked) {
            this.ResidualEnvironmentRisk.EnvironmentSelected = true;
          } else {
            this.ResidualEnvironmentRisk.EnvironmentSelected = false;
            this.ResidualEnvironmentRisk = new EnvironmentRisk();
          }
        }
        if (Category === "Reputation") {
          if (Checked) {
            this.ResidualReputationRisk.ReputationSelected = true;
          } else {
            this.ResidualReputationRisk.ReputationSelected = false;
            this.ResidualReputationRisk = new ReputationRisk();
          }
        }
        if (Category === "NPT") {
          if (Checked) {
            this.ResidualNPTRisk.NPTSelected = true;
          } else {
            this.ResidualNPTRisk.NPTSelected = false;
            this.ResidualNPTRisk = new NPTRisk();
          }
        }
        break;
      case RiskConstantsService.RiskType.Potential:
        break;
    }
  }

  /**
   * Check the checkbox
   * @param RiskType : risk type i.e. Potential
   * @param Category : category type i.e. PEAR
   */
  selectAssessmentSection(Checked: any, RiskType: any, Category: string) {
    switch (RiskType) {
      case RiskConstantsService.RiskType.Assessment:
        if (Category === "People") {
          if (Checked) {
            this.RiskassessmentPeople.PeopleSelected = true;
          } else {
            this.RiskassessmentPeople.PeopleSelected = false;
            this.RiskassessmentPeople = new PeopleRisk();
          }
        }
        if (Category === "Assets") {
          if (Checked) {
            this.RiskassessmentAssets.AssetsSelected = true;
          } else {
            this.RiskassessmentAssets.AssetsSelected = false;
            this.RiskassessmentAssets = new AssetsRisk();
          }
        }
        if (Category === "Environment") {
          if (Checked) {
            this.RiskassessmentEnvironment.EnvironmentSelected = true;
          } else {
            this.RiskassessmentEnvironment.EnvironmentSelected = false;
            this.RiskassessmentEnvironment = new EnvironmentRisk();
          }
        }
        if (Category === "Reputation") {
          if (Checked) {
            this.RiskassessmentReputation.ReputationSelected = true;
          } else {
            this.RiskassessmentReputation.ReputationSelected = false;
            this.RiskassessmentReputation = new ReputationRisk();
          }
        }
        if (Category === "NPT") {
          if (Checked) {
            this.RiskassessmentNPT.NPTSelected = true;
          } else {
            this.RiskassessmentNPT.NPTSelected = false;
            this.RiskassessmentNPT = new NPTRisk();
          }
        }
        break;
      case RiskConstantsService.RiskType.Potential:
        break;
    }
  }
  createPEARList() {
    this.raiseRisk = new RaiseRisk();
    this.raiseRisk.PotentialPEARList = [];
    this.raiseRisk.ResidualPEARList = [];
    this.raiseRisk.RiskAssessmentPEARList = [];
    this.actionList.forEach((element: { UnitId: number; }) => {
      element.UnitId = parseInt(this.selectedUnit.UnitId);
    });
    this.raiseRisk.ActionDetails = this.actionList;
    this.riskRequest.RaisedBy = this.loggedInUserJSON.UserId;
    this.raiseRisk.RiskRequest = this.riskRequest;
    if (this.PotentialPeopleRisk) {
      const tempPear = new PearDetails();
      tempPear.RiskPear = this.PotentialPeopleRisk.PeopleRiskPear;
      tempPear.RiskSeverity = this.PotentialPeopleRisk.PeopleRiskSeverity;
      tempPear.RiskLikelihood = this.PotentialPeopleRisk.PeopleRiskLikelihood;
      this.raiseRisk.PotentialPEARList.push(tempPear);
    }
    if (this.PotentialEnvironmentRisk) {
      const tempEnvironmentPear = new PearDetails();
      tempEnvironmentPear.RiskPear = this.PotentialEnvironmentRisk.EnvironmentRiskPear;
      tempEnvironmentPear.RiskSeverity = this.PotentialEnvironmentRisk.EnvironmentRiskSeverity;
      tempEnvironmentPear.RiskLikelihood = this.PotentialEnvironmentRisk.EnvironmentRiskLikelihood;

      this.raiseRisk.PotentialPEARList.push(tempEnvironmentPear);
    }
    if (this.PotentialAssetsRisk) {
      const tempAssetsPear = new PearDetails();
      tempAssetsPear.RiskPear = this.PotentialAssetsRisk.AssetsRiskPear;
      tempAssetsPear.RiskSeverity = this.PotentialAssetsRisk.AssetsRiskSeverity;
      tempAssetsPear.RiskLikelihood = this.PotentialAssetsRisk.AssetsRiskLikelihood;
      this.raiseRisk.PotentialPEARList.push(tempAssetsPear);
    }
    if (this.PotentialReputationRisk) {
      const tempReputationPear = new PearDetails();
      tempReputationPear.RiskPear = this.PotentialReputationRisk.ReputationRiskPear;
      tempReputationPear.RiskSeverity = this.PotentialReputationRisk.ReputationRiskSeverity;
      tempReputationPear.RiskLikelihood = this.PotentialReputationRisk.ReputationRiskLikelihood;
      this.raiseRisk.PotentialPEARList.push(tempReputationPear);
    }
    if (this.PotentialNPTRisk) {
      const tempNPTPear = new PearDetails();
      tempNPTPear.RiskPear = this.PotentialNPTRisk.NPTRiskPear;
      tempNPTPear.RiskSeverity = this.PotentialNPTRisk.NPTRiskSeverity;
      tempNPTPear.RiskLikelihood = this.PotentialNPTRisk.NPTRiskLikelihood;
      this.raiseRisk.PotentialPEARList.push(tempNPTPear);
    }

    if (this.ResidualPeopleRisk) {
      const residualPear = new PearDetails();
      residualPear.RiskPear = this.ResidualPeopleRisk.PeopleRiskPear;
      residualPear.RiskSeverity = this.ResidualPeopleRisk.PeopleRiskSeverity;
      residualPear.RiskLikelihood = this.ResidualPeopleRisk.PeopleRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualPear);
    }
    if (this.ResidualEnvironmentRisk) {
      const residualEnvPear = new PearDetails();
      residualEnvPear.RiskPear = this.ResidualEnvironmentRisk.EnvironmentRiskPear;
      residualEnvPear.RiskSeverity = this.ResidualEnvironmentRisk.EnvironmentRiskSeverity;
      residualEnvPear.RiskLikelihood = this.ResidualEnvironmentRisk.EnvironmentRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualEnvPear);
    }
    if (this.ResidualAssetsRisk) {
      const residualAssetsPear = new PearDetails();
      residualAssetsPear.RiskPear = this.ResidualAssetsRisk.AssetsRiskPear;
      residualAssetsPear.RiskSeverity = this.ResidualAssetsRisk.AssetsRiskSeverity;
      residualAssetsPear.RiskLikelihood = this.ResidualAssetsRisk.AssetsRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualAssetsPear);
    }
    if (this.ResidualReputationRisk) {
      const residualReputationPear = new PearDetails();
      residualReputationPear.RiskPear = this.ResidualReputationRisk.ReputationRiskPear;
      residualReputationPear.RiskSeverity = this.ResidualReputationRisk.ReputationRiskSeverity;
      residualReputationPear.RiskLikelihood = this.ResidualReputationRisk.ReputationRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualReputationPear);
    }
    if (this.ResidualNPTRisk) {
      const residualNPTPear = new PearDetails();
      residualNPTPear.RiskPear = this.ResidualNPTRisk.NPTRiskPear;
      residualNPTPear.RiskSeverity = this.ResidualNPTRisk.NPTRiskSeverity;
      residualNPTPear.RiskLikelihood = this.ResidualNPTRisk.NPTRiskLikelihood;
      this.raiseRisk.ResidualPEARList.push(residualNPTPear);
    }

    if (this.RiskassessmentPeople) {
      const assessmentPear = new PearDetails();
      assessmentPear.RiskPear = this.RiskassessmentPeople.PeopleRiskPear;
      assessmentPear.RiskSeverity = this.RiskassessmentPeople.PeopleRiskSeverity;
      assessmentPear.RiskLikelihood = this.RiskassessmentPeople.PeopleRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentPear);
    }
    if (this.RiskassessmentEnvironment) {
      const assessmentEnvPear = new PearDetails();
      assessmentEnvPear.RiskPear = this.RiskassessmentEnvironment.EnvironmentRiskPear;
      assessmentEnvPear.RiskSeverity = this.RiskassessmentEnvironment.EnvironmentRiskSeverity;
      assessmentEnvPear.RiskLikelihood = this.RiskassessmentEnvironment.EnvironmentRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentEnvPear);
    }
    if (this.RiskassessmentAssets) {
      const assessmentAssetsPear = new PearDetails();
      assessmentAssetsPear.RiskPear = this.RiskassessmentAssets.AssetsRiskPear;
      assessmentAssetsPear.RiskSeverity = this.RiskassessmentAssets.AssetsRiskSeverity;
      assessmentAssetsPear.RiskLikelihood = this.RiskassessmentAssets.AssetsRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentAssetsPear);
    }
    if (this.RiskassessmentReputation) {
      const assessmentsReputationPear = new PearDetails();
      assessmentsReputationPear.RiskPear = this.RiskassessmentReputation.ReputationRiskPear;
      assessmentsReputationPear.RiskSeverity = this.RiskassessmentReputation.ReputationRiskSeverity;
      assessmentsReputationPear.RiskLikelihood = this.RiskassessmentReputation.ReputationRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentsReputationPear);
    }
    if (this.RiskassessmentNPT) {
      const assessmentsNPTPear = new PearDetails();
      assessmentsNPTPear.RiskPear = this.RiskassessmentNPT.NPTRiskPear;
      assessmentsNPTPear.RiskSeverity = this.RiskassessmentNPT.NPTRiskSeverity;
      assessmentsNPTPear.RiskLikelihood = this.RiskassessmentNPT.NPTRiskLikelihood;
      this.raiseRisk.RiskAssessmentPEARList.push(assessmentsNPTPear);
    }
  }

  /**
   * send to line graph
   */
  sendtoLineGraph() {
    this.createPEARList();
    this.data = [];
    this.raiseRisk.PotentialPEARList.forEach(pearDetails => {
      if (
        this.max <
        pearDetails.RiskSeverity *
        this.riskService.ChangeAlphabetToNumber(pearDetails.RiskLikelihood)
      ) {
        this.max =
          pearDetails.RiskSeverity *
          this.riskService.ChangeAlphabetToNumber(pearDetails.RiskLikelihood);
        this.pear = pearDetails.RiskPear.toString();
      }
    });
    this.raiseRisk.PotentialPEARList.forEach(element => {
      if (element.RiskPear === this.pear) {
        const custData = new CustomObject();
        custData.module = +element.RiskSeverity;
        custData.value = this.riskService.ChangeAlphabetToNumber(
          element.RiskLikelihood
        );
        custData.pearName = this.pear;
        this.data.push(custData);
      }
    });
    this.raiseRisk.RiskAssessmentPEARList.forEach(element => {
      if (element.RiskPear === this.pear) {
        const custData = new CustomObject();
        custData.module = +element.RiskSeverity;
        custData.value = this.riskService.ChangeAlphabetToNumber(
          element.RiskLikelihood
        );
        custData.pearName = this.pear;
        this.data.push(custData);
      }
    });
    this.raiseRisk.ResidualPEARList.forEach(element => {
      if (element.RiskPear === this.pear) {
        const custData = new CustomObject();
        custData.module = +element.RiskSeverity;
        custData.value = this.riskService.ChangeAlphabetToNumber(
          element.RiskLikelihood
        );
        custData.pearName = this.pear;
        this.data.push(custData);
      }
    });
    this.baseService.setDataForLine(this.data);
  }
  downloadPDF() {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "Risk",
        SourceId: this.selectedRiskRequestId
      }
    };
    this.riskService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this)
    );
  }

  callbackMethodForDownloadPDF(response: any) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName =
        "pdf_riskrequest" + this.selectedRiskRequestId + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }
  trackDetails(raiseRisk: RaiseRisk) {
    if (!this.selectedRiskRequestId) {
      this.updateriskDataForDetails = [];
    } else {
      this.updateriskDataForDetails = JSON.parse(
        this.riskService.getupdatedRiskData()
      );
    }
    
    const columnNames = Object.getOwnPropertyNames(this.riskRequest);
    columnNames.forEach(element => {
      if (this.updateriskDataForDetails === null) 
      {
        this.retVal = false;
      } 
      else 
      {
        this.retVal = this.commonService.isDataEqual(
          this.updateriskDataForDetails[element],
          this.riskRequest[element]
        );
      }
     // if (this.updateriskDataForDetails[element] instanceof Array) {
      if (this.retVal === false) 
      {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        if (
          element === "PotentialPEARList" ||
          element === "ResidualPEARList" ||
          element === "RiskAssessmentPEARList" ||
          element === "ActionDetails"
        ) {
          const colNames = Object.getOwnPropertyNames(
            this.updateriskDataForDetails[element][0]
          );
          for (
            let indexInner = 0;
            indexInner < this.updateriskDataForDetails[element].length;
            indexInner++
          ) {
            colNames.forEach(innerElement => {
              let newOriginalElement = this.isNew
                ? null
                : this.updateriskDataForDetails[element][indexInner];
              let newUpdatedElement: any = raiseRisk[element][indexInner];

              if (
                !this.commonService.isDataEqual(
                  newOriginalElement[innerElement],
                  newUpdatedElement[innerElement]
                )
              ) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName =
                  element + newOriginalElement.RiskPear + innerElement;
                userLoginActivity.OldValue = newOriginalElement[innerElement];
                userLoginActivity.NewValue = newUpdatedElement[innerElement];
                this.userActivityList.push(userLoginActivity);
              }
            });
          }
        }
      else if (element === "RiskRequestId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        // this.raiseRiskAllMaster.RiskSource.forEach(observe => {
        //   if (
        //     observe.RiskSourceId ===
        //     parseInt(this.riskRequest.RiskSourceId.toString())
        //   ) {
        //     userLoginActivityObj1.NewValue += observe.Source;
        //   }
        //   if (
        //     observe.RiskSourceId ===
        //     parseInt(this.updateriskDataForDetails.RiskSourceId)
        //   ) {
        //     userLoginActivityObj1.OldValue += observe.Source;
        //   }
        // });
        userLoginActivity.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivity.NewValue = raiseRisk.RiskRequest.RiskRequestId;
        this.userActivityList.push(userLoginActivityObj1);
      } 
      else if (element === "RaisedBy") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        // this.raiseRiskAllMaster.Project.forEach(observe => {
        //   if (
        //     observe.ProjectId ===
        //     parseInt(this.riskRequest.ProjectId.toString())
        //   ) {
        //     userLoginActivityObj1.NewValue += observe.ProjectName;
        //   }
        //   if (
        //     observe.ProjectId ===
        //     parseInt(this.updateriskDataForDetails.ProjectId)
        //   ) {
        //     userLoginActivityObj1.OldValue += observe.ProjectName;
        //   }
        // });
         
        userLoginActivityObj1.OldValue = this.isNew
          ? null
          : this.updateriskDataForDetails[element];
        
        userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.RaisedBy;
       
        this.userActivityList.push(userLoginActivityObj1);
      } 
      else if (element === "RiskSourceId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        // 
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.RiskSourceId;
        this.userActivityList.push(userLoginActivityObj1);
      }

      else if (element === "ProjectId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        // this.raiseRiskAllMaster.RiskControlTechniques.forEach(observe => {
        //   if (
        //     observe.RiskControlTechniquesId ===
        //     parseInt(this.riskRequest.RiskControlTechniquesId.toString())
        //   ) {
        //     userLoginActivityObj1.NewValue += observe.ControlTechnique;
        //   }
        //   if (
        //     observe.RiskControlTechniquesId ===
        //     parseInt(this.updateriskDataForDetails.RiskControlTechniquesId)
        //   ) {
        //     userLoginActivityObj1.OldValue += observe.ControlTechnique;
        //   }
        // });
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ProjectId;
        this.userActivityList.push(userLoginActivityObj1);
      }
      //  else {
      //   if (this.updateriskDataForDetails.length === 0) {
      //     this.retVal = false;
      //     this.isNew = true;
      //   } else {
      //     this.retVal = this.commonService.isDataEqual(
      //       this.updateriskDataForDetails[element],
      //       raiseRisk.RiskRequest[element]
      //     );
      //   }
      //   if (this.retVal === false) {
      //     const userLoginActivity = new UserLogInActivity();
      //     userLoginActivity.FieldName = element;
      //     userLoginActivity.OldValue = this.isNew
      //       ? null
      //       : this.updateriskDataForDetails[element];
      //     userLoginActivity.NewValue = this.riskRequest[element];
      //     this.userActivityList.push(userLoginActivity);
      //   }

        
      // }
      else if (element === "LocationId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.LocationId;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "RiskTitle") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.RiskTitle;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "RiskManagementToolId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.RiskManagementToolId;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "ActivityLeadingToHazard") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ActivityLeadingToHazard;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "HazardIdentified") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.HazardIdentified;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "ThreatIdentified") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ThreatIdentified;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "Consequences") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.Consequences;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "PotentialRiskPear") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.PotentialRiskPear;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "PotentialRiskLikelihood") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.PotentialRiskLikelihood;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "PotentialRiskSeverity") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.PotentialRiskSeverity;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "RiskControlTechniquesId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.RiskControlTechniquesId;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "ControlMeasure") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ControlMeasure;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "ContengencyPlan") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ContengencyPlan;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "ResidualRiskLikelihood") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ResidualRiskLikelihood;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "ResidualRiskSeverity") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ResidualRiskSeverity;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "AssessmentRiskPear") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.AssessmentRiskPear;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "AssessmentRiskLikelihood") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.AssessmentRiskLikelihood;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "AssessmentRiskSeverity") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.AssessmentRiskSeverity;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "RiskMovement") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.RiskMovement;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "InActive") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.InActive;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "PotentialPEARList") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue =raiseRisk.RiskRequest.PotentialPEARList;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "ResidualPEARList") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ResidualPEARList;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "RiskAssessmentPEARList") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.RiskAssessmentPEARList;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "UnitId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = "UnitId";
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.UnitId;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "Status") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.Status;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "RiskId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = element;
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.RiskId;
        this.userActivityList.push(userLoginActivityObj1);
      }
      else if (element === "ContractId") {
        const userLoginActivityObj1 = new UserLogInActivity();
        userLoginActivityObj1.FieldName = "Contract Number";
        userLoginActivityObj1.OldValue = this.isNew
        ? null
        : this.updateriskDataForDetails[element];
      
      userLoginActivityObj1.NewValue = raiseRisk.RiskRequest.ContractId;
        this.userActivityList.push(userLoginActivityObj1);
      }
    }

    });
    if (this.userActivityList.length > 0) {
      this.commonService.saveUserActivityDetails(
        raiseRisk.RiskRequest.RiskRequestId,
        new Date(),
        "Risk",
        this.loggedInUserJSON.UserId,
        this.userActivityList
      );
    }
  }
  deleteRiskRequest() {
    if (!this.deletionReason) {
      this.isDeletionreason = true;
    } else {
      this.alertType = ConstantsService.Confirm;
      this.confirmMessage = "Sure you want to delete it?";
    }
  }
  callbackMethodForDeleteRisk(response: { Success: boolean; }) {
    if (response.Success === true) {
      // this.alertType = ConstantsService.Success;
      // this.successDetails = 'Risk has been Deleted';
      this.notificationsService.toastNotify(
        "success",
        "Success Message",
        "Risk has been Deleted."
      );
      this.router.navigate([RiskConstantsService.RedirectUrls.MyRiskRequest]);
    }
  }
  savePDF(riskId: number) {
    const apiRequest = {
      Model: {
        ProcessName: "Risk",
        SourceId: riskId
      }
    };
    this.riskService.savePDF(
      apiRequest,
      this.callbackMethodForSavePDF.bind(this)
    );
  }
  callbackMethodForSavePDF(response: any) { }
  updateAction() {
    if (this.validateForm()) {
      this.actionDetailsForHseAdvisor.SourceId = this.riskRequest.RiskRequestId;
      this.actionDetailsForHseAdvisor.ProcessName =
        ActiontrackerConstantsService.ActiontrackerModuleConst.Risk;
      this.actionList.forEach(element => {
        element.UnitId = parseInt(this.selectedUnit.UnitId);
      });
      this.actionDetailsForHseAdvisor.ActionDetails = this.actionList;
      this.actionDetailsForHseAdvisor.RaisedBy = this.loggedInUserJSON.UserId;
      const apiRequest = {
        Model: this.actionDetailsForHseAdvisor
      };
      this.riskService.UpdateActionsForRisk(
        apiRequest,
        this.callbackFromUpdateActionHseAdvisor.bind(this)
      );
    }
  }
  callbackFromUpdateActionHseAdvisor(response: any) { }
  checkPopUpValidation(action: any, actionId: any) {
    this.validatePopUp = true;
    switch (action) {
      case "Cancel":
        if (this.cancellationReason === "") {
          this.showCancellationmsg = true;
          this.validatePopUp = false;
        }
        if (this.validatePopUp === true) {
          this.cancelAction(actionId);
        }
        break;
      case "Delete":
        if (this.deletionReason === "") {
          this.showDeletionmsg = true;
          this.validatePopUp = false;
        }
        if (this.validatePopUp === true) {
          this.deleteAction(actionId);
        }
        break;
    }
  }
  cancelAction(cancelActionId: any) {
    if (this.cancelActionId > 0) {
      this.cancelRecord = true;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.cancelActionId,
          CancellationReason: this.cancellationReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: this.cancelStatusId
        }
      };
      this.observationService.cancelactiondetails(
        apiRequest,
        this.callbackMethodForCancelActionDetails.bind(this)
      );
    }
  }
  callbackMethodForCancelActionDetails(response: any) {
    this.cancelRecord = false;
    this.cancellationReason = "";
    this.ngOnInit();
  }
  deleteAction(deleteActionId: any) {
    if (this.deleteActionId > 1) {
      this.deleteRecord = true;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.deleteActionId,
          DeletionReason: this.deletionReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: this.actionStatusId
        }
      };
      this.observationService.deleteactiondetails(
        apiRequest,
        this.callbackMethodForDeleteActionDetails.bind(this)
      );
    }
  }
  callbackMethodForDeleteActionDetails(response: any) {
    this.deleteRecord = false;
    this.deletionReason = "";
    this.riskLoaded = false;
    this.ngOnInit();
  }
  cancelAssigned(actionId: any, index: any) {
    this.cancelRecord = true;
    this.cancelActionId = actionId;
  }
  deleteAssigned(actionId: number, index: any) {
    this.deleteRecord = true;
    this.deleteActionId = actionId;
  }
  onCancelClick() {
    this.cancelRecord = false;
    this.cancellationReason = "";
  }
  onCancel() {
    this.deleteRecord = false;
    this.deletionReason = "";
  }
  onPreviousClick() {
    this.isNext = true;
    this.riskIndex = -1;
    this.disableRisk = false;
    this.riskIds = this.riskService.getAllRiskIds();
    this.riskIds.forEach((element, index) => {
      if (element == this.selectedRiskRequestId && index - 1 != null) {
        this.riskIndex = index - 1;
        if (this.riskIndex <= 0) {
          this.isPrevious = false;
        } else {
          this.isPrevious = true;
        }
        return;
      }
    });
    this.selectedRiskRequestId = this.riskIds[this.riskIndex];
    if (this.riskIndex > -1) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          RiskRequestId: this.selectedRiskRequestId
        }
      };
      this.riskService.getRiskRequestForEdit(
        apiRequest,
        this.successGetRiskRequestForEdit.bind(this)
      );
      this.router.navigate(["risk/raise-risk/" + this.selectedRiskRequestId]);
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.riskIndex = -1;
    this.disableRisk = false;
    this.riskIds = this.riskService.getAllRiskIds();
    this.riskIds.forEach((element, index) => {
      if (element == this.selectedRiskRequestId && index + 1 != null) {
        this.riskIndex = index + 1;
        if (this.riskIndex + 1 == this.riskIds.length) {
          this.isNext = false;
        } else {
          this.isNext = true;
        }
        return;
      }
    });
    this.selectedRiskRequestId = this.riskIds[this.riskIndex];
    if (this.riskIndex > -1) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          RiskRequestId: this.selectedRiskRequestId
        }
      };
      this.riskService.getRiskRequestForEdit(
        apiRequest,
        this.successGetRiskRequestForEdit.bind(this)
      );
      this.router.navigate(["risk/raise-risk/" + this.selectedRiskRequestId]);
    }
  }
  getAllModules() {
    this.masterscreenService.getAllModules(
      null,
      this.callbackMethodForGetAllModules.bind(this)
    );
  }
  callbackMethodForGetAllModules(response: { Success: any; Result: any[]; }) {
    if (response.Success) {
      this.moduleList = response.Result;
      this.moduleList.forEach(element => {
        if (element.ModuleName === "Risk") {
          this.moduleId = element.ModuleId;
        }
      });
    }
  }
  submitSpecificationData() {
    this.specificationDetailsData.RuleId = this.lifeSavingCheckedValueData;
    this.specificationDetailsData.SourceId = this.riskRequest.RiskRequestId;
    this.specificationDetailsData.ModuleId = this.moduleId;

    const apiRequest = {
      Model: this.specificationDetailsData
    };
    this.observationService.submitSpecificationData(
      apiRequest,
      this.callbackMethodForSubmitSpecificationData.bind(this)
    );
  }

  callbackMethodForSubmitSpecificationData(response: { Success: any; }) {
    if (response.Success) {
    }
  }
  categoryCheckedEmittedValue(data: any[]) {
    this.lifeSavingCheckedValueData = data;
  }
  nodeSelected(event: { node: any; }) {
    this.selectedUnit = event.node;
    if (this.selectedUnit.children && this.selectedUnit.children.length > 0) {
      this.selectedUnit.expanded = true;
    }
    this.getPermissionDetails(this.selectedUnit.UnitId);
    this.isEmployeeUnit=true;
    if(event.node.UnitTypeId == 2)
    {
      this.isEmployeeUnit=false;
      this.getContractDetails(this.selectedUnit.UnitId);
    }
    else{
      this.selectedContractId =0;
      this.raiseRisk.RiskRequest.ContractId = 0;
    }
  }
  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        "UnitId": unitId
      },
    };
    this.masterscreenService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this)
    );
  }
  callbackMethodForContractDetails(response) {
     
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach(contract => {
      this.contracts.push({ label: contract.ContractNumber, value: contract.UnitContractDetailsId });
      
    });
    if (this.raiseRisk.RiskRequest.RiskId !== 0 && this.raiseRisk.RiskRequest.RiskId && this.contracts.some(c => c.value == this.riskRequest.ContractId.toString())) {
      let currentContract = this.contracts.find(c => c.value.toString() === this.riskRequest.ContractId.toString());
    
      this.isContractErrorMsg=false;
      this.checkHolder(currentContract);
      this.isContractHolder=false;
      if(currentContract!=null)
      {
      contractHolderId = response.find(h => h.UnitContractDetailsId.toString() === this.riskRequest.ContractId.toString()).ContractHolderId
      this.isContractHolder = contractHolderId === this.loggedInUserJSON.UserId ? true : false;
      }
    }
    else 
    {
      this.isContractErrorMsg=true;
    }
  }
  checkHolder(event) {
    
    this.selectedContractId=0;
    let contract;
    contract = this.unitContractDetails.find(contract => contract.UnitContractDetailsId === event.value);
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isContractErrorMsg=false;
      this.isHasContractDetails = true;
      this.selectedContractId=event.value;
     
    } 
    else {
      this.isContractErrorMsg=true;
      this.isHasContractDetails = false;
    }
  }
  callbackMethodForGetTreeData(response: { Result: UnitTreeNode[] | null; }) {
    if (response.Result !== null) {
      this.unitTree = response.Result;
      if (this.sourceId === 0) {
        this.unitTree.forEach(element => {
          this.compareTreeNode(element, 0);
        });
      }
    }
    this.getAllMasterForRaiseRisk();
  }
  compareTreeNode(node: UnitTreeNode, selectedNode: number) {
    var isFound: boolean = false;
    this.unitList.forEach(element => {
      if (element.UnitId === node.UnitId) {
        isFound = true;
      }
    });
    if (!isFound || !node.IsActive) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.UnitId === selectedNode) {
      this.selectedUnit = node;
      this.expandParents(this.selectedUnit);
    }
    if (node.children && node.children.length > 0) {
      node.selectable = false;
      node.children.forEach((element: any) => {
        var isFound: boolean = false;
        this.unitList.forEach(unit => {
          if (unit.UnitId === element.UnitId) {
            isFound = true;
          }
        });
        if (!isFound || !element.IsActive) {
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.UnitId === selectedNode) {
          this.selectedUnit = element;
          this.expandParents(this.selectedUnit);
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
      });
    }
  }
  expandParents(node: { parent: any }) {
    if (node.parent) {
      node.parent.expanded = true;
      this.expandParents(node.parent);
    }
  }
  onInputFilesUpdated(files: any[], type: any, index: number) {
    switch (type) {
      case "RiskAction":
        for (let i = 0; i < this.actionList.length; i++) {
          if (i === index) {
            this.actionList[index].Files = files;
          }
        }
        break;
      default:
        break;
    }
  }
  showActions(actionId: any, processId: any) {
    this.router.navigate([
      "/actiontracker/all-action-details",
      actionId,
      { processId: processId }
    ]);
  }
  getRemarks(remarks: string | String, type: any, index: string | number) {
    switch (type) {
      case "ActivityLeadingToHazard":
        this.riskRequest.ActivityLeadingToHazard = remarks;
        break;
      case "HazardIdentified":
        this.riskRequest.HazardIdentified = remarks;
        break;
      case "ThreatIdentified":
        this.riskRequest.ThreatIdentified = remarks;
        break;
      case "Consequences":
        this.riskRequest.Consequences = remarks;
        break;
      case "ControlMeasure":
        this.riskRequest.ControlMeasure = remarks;
        break;
      case "ContengencyPlan":
        this.riskRequest.ContengencyPlan = remarks;
        break;
      case "Action":
        this.actionList[index].Action = remarks;
        break;
      case "CancellationReason":
        this.cancellationReason = remarks;
        break;
      case "DeletionReason":
        this.deletionReason = remarks;
        break;
      default:
        break;
    }
  }
  getOutput(event: any) {
    if (event) {
      this.ngOnInit();
    }
  }

  saveAsDraft() {
    if (this.validateForm()) {
      const raiseRisk = new RaiseRisk();
      this.baseService.showRootLoader = true;
      this.bindActionOwnerIdToList();
      this.createPEARList();
      this.raiseRisk.RiskRequest.UnitId = parseInt(this.selectedUnit.UnitId);
      this.raiseRisk.RiskRequest.IsDraft = true;
      this.raiseRisk.RiskRequest.RiskId = this.selectedRiskRequestId;
      this.raiseRisk.RiskRequest.ContractId = this.isEmployeeUnit?0: this.selectedContractId;
      const apiRequest = {
        Model: this.raiseRisk
      };
      this.riskService.raiseRisk(apiRequest, this.raiseRiskSuccess.bind(this));
    }
    else {
      this.baseService.showRootLoader = false;
    }
  }

   //BOC Pritesh
   ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "Risk";
    this.ReportRecordId = this.selectedRiskRequestId;
    this.ReportProcessId = 0;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }
  //EOC Pritesh


}

export class CustomObject {
  value: number | undefined;
  module: number | undefined;
  pearName: string | undefined;
}

// export class SpecificationData {
// 	ModuleId: number;
// 	SourceId: number;
// 	RuleId: any[] = [];
// 	LstCategoryRuleGroupedByCategoryId: any[] = [];
// 	Checked: boolean;
// 	CategoryName: string;
// }